import React from "react";
import axios from "axios";

const ImageUploader = ({ onUpload }) => {
    const handleImageUpload = async (file) => {
        const formData = new FormData();
        formData.append("image", file);

        try {
            const token = localStorage.getItem("token");
            const response = await axios.post("/api/images/upload-image", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`,
                },
            });
            onUpload(response.data.path); // Return the uploaded image path
        } catch (error) {
            console.error("Error uploading image:", error);
            alert("Failed to upload image. Please try again.");
        }
    };

    return (
        <div className="image-uploader">
            <input
                type="file"
                accept="image/*"
                onChange={(e) => handleImageUpload(e.target.files[0])}
                className="content-image-upload"
            />
        </div>
    );
};

export default ImageUploader;
